import type { ReactNode } from 'react';

/** Envoltorio posicionado común a las tres tarjetas de hover (hoja/sucursal/cliente). */
export function HoverShell({ x, y, children }: { x: number; y: number; children: ReactNode }) {
  return (
    <div
      className="pointer-events-none absolute z-10 grid gap-1 rounded-lg border border-black/15 bg-[var(--occ-surface)] px-3 py-2 text-xs shadow-lg dark:border-white/20"
      style={{ left: x, top: y, transform: 'translate(-50%, -100%)' }}
    >
      {children}
    </div>
  );
}
